import React from "react";
import HomeNav from "components/Navbars/HomeNav.js";
import { Link } from 'react-router-dom';

// reactstrap components
import {  
  Card,
  CardBody,
  CardText,
  CardImg,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import HomePageCarousel from "../components/Carousels/HomePageCarousel";
import DefaultFooter from "components/Footers/DefaultFooter.js";


function LiquidLoveHome() {

  React.useEffect(() => {
    document.title = 'Liquid Love Home';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>       
      <div className="wrapper">        
        <HomePageHeader />
        <HomeNav />
        <HomePageCarousel />
        <div
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
        >
          <div className="text-center">
          <div style={{color: "white"}}><h3 className="title">Liquid Love</h3></div>                                
            <Link to="/liquidlove/patient" className="btn btn-primary">Patient Blood Request</Link>          
              &nbsp;&nbsp;&nbsp;
            <Link to="/liquidlove/donor-consent" className="btn btn-primary">Blood Donor Sign Up</Link>
          </div>        
          <br></br><br></br>
          <div >
          <Container>            
            <div className="team text-center">
              <Row>
                <Col md="4">
                  <div className="team-player">
                  <Card style={{ width: "20rem" }}>
                    <CardImg alt="..." className="rounded-circle img-fluid img-raised" src={require("assets/img/3.jpg")} top></CardImg>
                    <CardBody>
                      <CardText align="left">
<b>I shall be with you, wherever you are, guarding you and guiding you.March on, have no fear.</b>
                      </CardText>
                    </CardBody>
                  </Card>                                       
                  </div>
                </Col>
                <Col md="4"></Col>
                <Col md="4">
                  <div className="team-player">
                  <Card style={{ width: "20rem" }}>
                  <CardImg alt="..." className="rounded-circle img-fluid img-raised" src={require("assets/img/Sai4_NewYR09.jpg")} top></CardImg>
                    <CardBody>
                      <CardText align="left">
<b>If you lift the hand to serve, to help, to console, to encourage another man, you are lifting it for God, for God is in every man.</b>
                      </CardText>
                    </CardBody>
                  </Card>                    
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
            
            </div>  
        <DefaultFooter />
      </div>
    </>
  );
}

export default LiquidLoveHome;
